import { ApiFailure } from '@/api/client'
import type { TFunction } from 'i18next'

/** Turns a failed login / password call into one sentence: what failed, what to do. */
export function authErrorText(err: unknown, t: TFunction): string {
  if (!(err instanceof ApiFailure)) return t('errorServer')
  if (err.kind === 'network') return t('errorNetworkLogin')
  if (err.kind === 'server') return t('errorServer')
  switch (err.code) {
    case 'bad_credentials':
      return t('errorBadCredentials')
    case 'too_many_attempts':
      return t('errorTooManyAttempts', {
        minutes: Math.max(1, Math.ceil((err.retryAfterSec ?? 900) / 60)),
      })
    case 'account_locked':
      return t('errorAccountLocked')
    case 'wrong_password':
      return t('errorWrongPassword')
    default:
      return t('errorServer')
  }
}
